import {
  Component, OnInit, OnDestroy,
  ViewChild, ElementRef, ChangeDetectorRef, HostListener, NgZone
} from '@angular/core';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AppService } from '../app.service';
import { messageService } from '../message.service';
import { SuccessSnackbarComponent } from '../support/success-snackbar/success-snackbar.component';

export interface EsignField {
  fieldId: string;
  type: 'signature' | 'date' | 'initials' | 'text' | 'redact';
  x: number; y: number; w: number; h: number;
  layerNo: number;
  assignedUserId: number | null;
  assignedUserName: string;
  pageNo: number;
  label: string;
}

@Component({
  selector: 'app-esignature-setup',
  templateUrl: './esignature-setup.component.html',
  styles: [`
    .esign-doc-banner{background:linear-gradient(135deg,#f0f4ff,#e8f0fe);border:1px solid #c5d8fc;border-radius:6px;font-size:13px}
    .esign-panel{border:1px solid #dee2e6;border-radius:6px;overflow:hidden;background:#fff}
    .esign-panel-title{background:#f8f9fa;border-bottom:1px solid #dee2e6;padding:7px 10px;font-size:11px;font-weight:700;color:#495057;display:flex;align-items:center;gap:5px}
    .esign-field-toolbar{background:#f8f9fa;border:1px solid #dee2e6;border-radius:6px}
    .esign-field-btn{padding:4px 10px;border-radius:4px;font-size:11px;font-weight:600;border:1.5px solid;cursor:pointer;background:#fff;transition:all .15s}
    .signature-btn{border-color:#0056b3;color:#0056b3}.signature-btn.active-tool,.signature-btn:hover{background:#0056b3;color:#fff}
    .date-btn{border-color:#28a745;color:#28a745}.date-btn.active-tool,.date-btn:hover{background:#28a745;color:#fff}
    .initials-btn{border-color:#ffc107;color:#856404}.initials-btn.active-tool,.initials-btn:hover{background:#ffc107;color:#fff}
    .text-field-btn{border-color:#6c757d;color:#6c757d}.text-field-btn.active-tool,.text-field-btn:hover{background:#6c757d;color:#fff}
    .redact-btn{border-color:#343a40;color:#343a40}.redact-btn.active-tool,.redact-btn:hover{background:#343a40;color:#fff}
    .danger-btn{border-color:#dc3545;color:#dc3545}.danger-btn:hover{background:#dc3545;color:#fff}
    .esign-chip{position:absolute;display:flex;align-items:center;justify-content:center;border-radius:3px;font-size:10px;font-weight:700;user-select:none;box-sizing:border-box;pointer-events:all !important;will-change:left,top,width,height}
    .esign-chip.selected{box-shadow:0 0 0 2px #ff3d3d,0 2px 8px rgba(0,0,0,.3) !important}
    .chip-signature{background:rgba(0,86,179,.15);border:2px solid #0056b3;color:#003d82}
    .chip-date{background:rgba(40,167,69,.15);border:2px solid #28a745;color:#155724}
    .chip-initials{background:rgba(255,193,7,.2);border:2px solid #ffc107;color:#856404}
    .chip-text{background:rgba(108,117,125,.15);border:2px solid #6c757d;color:#343a40}
    .chip-redact{background:rgba(0,0,0,.85);border:2px solid #111;color:#fff}
    .chip-label{font-size:9px;padding:0 3px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;text-align:center;width:100%}
    .rh{position:absolute;width:8px;height:8px;background:#fff;border:1.5px solid #0056b3;border-radius:2px;z-index:10;pointer-events:all}
    .rh-nw{top:-4px;left:-4px;cursor:nw-resize}.rh-ne{top:-4px;right:-4px;cursor:ne-resize}
    .rh-sw{bottom:-4px;left:-4px;cursor:sw-resize}.rh-se{bottom:-4px;right:-4px;cursor:se-resize}
    .rh-n{top:-4px;left:50%;transform:translateX(-50%);cursor:n-resize}
    .rh-s{bottom:-4px;left:50%;transform:translateX(-50%);cursor:s-resize}
    .rh-w{left:-4px;top:50%;transform:translateY(-50%);cursor:w-resize}
    .rh-e{right:-4px;top:50%;transform:translateY(-50%);cursor:e-resize}
    .field-item{border:1px solid #e9ecef;border-radius:4px;padding:6px 8px;margin-bottom:4px;background:#fff}
    .field-item.selected{border-color:#0056b3;background:#e8f0fe}
    .field-badge{padding:2px 5px;border-radius:3px;font-size:10px;font-weight:700}
    .fb-sig{background:#d0e4ff;color:#0056b3}.fb-date{background:#d4edda;color:#155724}
    .fb-ini{background:#fff3cd;color:#856404}.fb-text{background:#e2e3e5;color:#383d41}
    .fb-red{background:#333;color:#fff}
    .layer-row{border:1px solid #e9ecef;border-radius:6px;padding:8px;background:#fafafa;margin-bottom:6px}
    .layer-badge{width:24px;height:24px;border-radius:50%;background:#0056b3;color:#fff;display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:700;flex-shrink:0}
    .sent-banner{background:#d4edda;border:1px solid #c3e6cb;border-radius:8px;padding:20px;text-align:center;color:#155724}
    .layer-search{width:100%;padding:4px 8px;border:1px solid #dee2e6;border-radius:3px;font-size:11px;margin-bottom:4px;outline:none}
  `]
})
export class EsignatureSetupComponent implements OnInit, OnDestroy {

  documentData: any = {};
  isProcessing = false;
  envelopeSent = false;
  sentEnvelopeData: any = null;

  pdfSrc: Uint8Array | null = null;
  viewerReady = false; pdfLoadError = false; pdfLoadErrorMsg = '';
  currentPage = 1; totalPages = 1;

  @ViewChild('fieldOverlay', { static: false }) fieldOverlay!: ElementRef<HTMLDivElement>;
  @ViewChild('pdfCanvas', { static: false }) pdfCanvas!: ElementRef<HTMLCanvasElement>;
  pdfJsLib: any; pdfDoc: any = null; pdfScale = 1.5;

  fields: EsignField[] = [];
  selectedFieldType: EsignField['type'] = 'signature';
  isPlacingField = false;
  selectedField: EsignField | null = null;

  pageFields: EsignField[] = [];
  signingOrderSummary: { layerNo: number; userName: string; fields: EsignField[] }[] = [];
  sigFieldCount = 0;
  redactCount = 0;
  hasUnassignedFields = false;
  sendBlockReason = '';
  canSend = false;

  private _dragField: EsignField | null = null;
  private _dragOX = 0; private _dragOY = 0;
  private _resizing = false;
  private _resField: EsignField | null = null;
  private _resHandle = '';
  private _resStartX = 0; private _resStartY = 0;
  private _resStart = { x: 0, y: 0, w: 0, h: 0 };
  private _overlayRect: DOMRect | null = null;
  private _chipEls = new Map<string, HTMLElement>();
  private _moveListener: ((e: MouseEvent) => void) | null = null;
  private _upListener: ((e: MouseEvent) => void) | null = null;

  groupUsersList: any[] = [];
  userDropdownList: any[] = [];
  filteredUserDropdownList: any[] = [];
  private _userSearch = '';
  get userSearchTxt(): string { return this._userSearch; }
  set userSearchTxt(v: string) { this._userSearch = v; this._filterUsers(); }

  readonly layerOptions = [1, 2, 3, 4];
  envelopeTitle = '';
  uiDateFormat = 'dd-MMM-yyyy';

  constructor(
    private appService: AppService,
    private router: Router,
    private snackBar: MatSnackBar,
    public message: messageService,
    private cdr: ChangeDetectorRef,
    private zone: NgZone
  ) {
    const nav = this.router.getCurrentNavigation();
    if (nav?.extras?.state) {
      this.documentData = nav.extras.state['documentData'] || {};
      try { sessionStorage.setItem('esign_dd', JSON.stringify(this.documentData)); } catch { }
    } else {
      const h = window.history.state;
      if (h?.documentData) {
        this.documentData = h.documentData || {};
        try { sessionStorage.setItem('esign_dd', JSON.stringify(this.documentData)); } catch { }
      } else {
        try { const d = sessionStorage.getItem('esign_dd'); if (d) this.documentData = JSON.parse(d); } catch { }
      }
    }
  }

  ngOnInit(): void {
    this.message.breadcrumbData = { ...this.message.breadcrumbData, thirdLevel: 'E-Signature' };
    const tz = JSON.parse(sessionStorage.getItem('getUserTimezoneDetails') || '{}');
    if (tz.uiDateFormat) this.uiDateFormat = tz.uiDateFormat.replace('DD', 'dd').replace('MON', 'MMM').replace('YYYY', 'yyyy');
    if (!this.documentData?.documentId) {
      try { const d = sessionStorage.getItem('esign_dd'); if (d) this.documentData = JSON.parse(d); } catch { }
    }
    if (this.documentData?.documentName) this.envelopeTitle = this.documentData.documentName + ' - E-Signature';
    this.loadGroupUsers();
    this.loadDocument();
    this.checkExistingEnvelope();
    this.updateDerivedState();
  }

  ngOnDestroy(): void { this._detach(); this._chipEls.clear(); }

  checkExistingEnvelope(): void {
    if (!this.documentData?.documentId || this.documentData.documentId === 'undefined') return;
    this.appService.getEsignEnvelopesByDocument(this.documentData.documentId, this.documentData.version
    ).subscribe({
      next: (list: any) => {
        if (!list?.length) return;
        const l = list[0];
        const st = l.envelopeStatus || l.status || '';
        if (['Sent', 'InProgress', 'Completed', 'Cancelled'].includes(st)) {
          this.envelopeSent = true; this.sentEnvelopeData = l;
          this.appService.getEsignEnvelope(l.envelopeNo).subscribe({
            next: (f: any) => { this.sentEnvelopeData = f; this.cdr.detectChanges(); }
          });
        }
        this.cdr.detectChanges();
      }, error: () => { }
    });
  }

  loadDocument(): void {
    if (!this.documentData?.documentId || this.documentData.documentId === 'undefined') return;
    if (!this.documentData?.version || this.documentData.version === 'undefined') return;
    this.isProcessing = true; this.pdfSrc = null; this.viewerReady = false; this.pdfLoadError = false;
    this.cdr.detectChanges();
    this.appService.getDocumentAsPdfForEsign(

      this.documentData.documentId, this.documentData.version
    ).subscribe({ next: (r: any) => this.handlePdfBytes(new Uint8Array(r.body), r), error: () => this.loadFallback() });
  }

  loadFallback(): void {
    this.appService.getDocumentsToViewForDms(
      this.documentData.documentId, this.documentData.version
    ).subscribe({ next: (r: any) => this.handlePdfBytes(new Uint8Array(r.body), r), error: () => this.setViewerError() });
  }

  handlePdfBytes(bytes: Uint8Array, r?: any): void {
    this.isProcessing = false;
    if ((window as any)['pdfjsLib']) {
      this.pdfJsLib = (window as any)['pdfjsLib'];
      this.pdfJsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';
      this._renderPdfBytes(bytes);
      return;
    }
    const script = document.createElement('script');
    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js';
    script.onload = () => {
      this.pdfJsLib = (window as any)['pdfjsLib'];
      this.pdfJsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';
      this._renderPdfBytes(bytes);
    };
    document.head.appendChild(script);
  }

  private _renderPdfBytes(bytes: Uint8Array): void {
    this.pdfJsLib.getDocument({ data: bytes }).promise.then((doc: any) => {
      this.pdfDoc = doc;
      this.totalPages = doc.numPages;
      this.viewerReady = true;
      this.cdr.detectChanges();
      setTimeout(() => this._renderPage(1), 50);
    }).catch(() => {
      this.pdfLoadError = true;
      this.pdfLoadErrorMsg = 'Document could not be rendered.';
      this.cdr.detectChanges();
    });
  }

  _renderPage(pageNum: number): void {
    if (!this.pdfDoc || !this.pdfCanvas?.nativeElement) return;
    this.currentPage = pageNum;
    this.pdfDoc.getPage(pageNum).then((page: any) => {
      const viewport = page.getViewport({ scale: this.pdfScale });
      const canvas = this.pdfCanvas.nativeElement;
      canvas.height = viewport.height;
      canvas.width = viewport.width;
      page.render({ canvasContext: canvas.getContext('2d')!, viewport }).promise.then(() => {
        this.updateDerivedState();
        this.cdr.detectChanges();
      });
    });
  }

  updateDerivedState(): void {
    this.pageFields = this.fields.filter(f => f.pageNo === this.currentPage);
    this.sigFieldCount = this.fields.filter(f => f.type !== 'redact').length;
    this.redactCount = this.fields.filter(f => f.type === 'redact').length;
    this.hasUnassignedFields = this.fields.some(f => f.type !== 'redact' && (!f.assignedUserId || !f.layerNo));

    const map = new Map<number, { layerNo: number; userName: string; fields: EsignField[] }>();
    for (const f of this.fields) {
      if (f.type === 'redact') continue;
      if (!map.has(f.layerNo)) map.set(f.layerNo, { layerNo: f.layerNo, userName: f.assignedUserName || '', fields: [] });
      const entry = map.get(f.layerNo)!;
      entry.fields.push(f);
      if (f.assignedUserName && !entry.userName) entry.userName = f.assignedUserName;
    }
    this.signingOrderSummary = Array.from(map.values()).sort((a, b) => a.layerNo - b.layerNo);

    // One-user-per-layer conflict check
    const layerUserMap = new Map<number, number>();
    let layerConflictMsg = '';
    for (const f of this.fields) {
      if (f.type === 'redact' || !f.assignedUserId || !f.layerNo) continue;
      if (layerUserMap.has(f.layerNo)) {
        if (layerUserMap.get(f.layerNo) !== f.assignedUserId) {
          layerConflictMsg = `Layer ${f.layerNo} has multiple users — one user per layer only`;
          break;
        }
      } else {
        layerUserMap.set(f.layerNo, f.assignedUserId);
      }
    }

    if (!this.envelopeTitle?.trim()) this.sendBlockReason = 'Enter an envelope title';
    else if (!this.sigFieldCount) this.sendBlockReason = 'Place at least one signature field';
    else if (this.hasUnassignedFields) this.sendBlockReason = 'Assign a signer to every field';
    else if (layerConflictMsg) this.sendBlockReason = layerConflictMsg;
    else this.sendBlockReason = '';

    this.canSend = !this.envelopeSent && !this.sendBlockReason;
  }

  onTitleChange(val: string): void { this.envelopeTitle = val; this.updateDerivedState(); }
  deselectField(): void { if (this.selectedField) { this.selectedField = null; this.cdr.detectChanges(); } }

  setViewerError(): void {
    this.isProcessing = false; this.pdfLoadError = true;
    this.pdfLoadErrorMsg = 'Preview not available. You can still place fields.';
    this.totalPages = 1; this.cdr.detectChanges();
  }

  onPdfLoaded(_?: any): void { }
  onPageChange(p: number): void { this._renderPage(p); }
  onPdfLoadError(_?: any): void { this.setViewerError(); }
  prevPage(): void { if (this.currentPage > 1) this._renderPage(this.currentPage - 1); }
  nextPage(): void { if (this.currentPage < this.totalPages) this._renderPage(this.currentPage + 1); }

  loadGroupUsers(): void {
    this.appService.getOneQmsUsersWithRolesVwDetails('DMS').subscribe({
      next: (res: any) => {
        this.groupUsersList = (res || []).filter((u: any) => u.userId != null);
        this.userDropdownList = this.groupUsersList.map((u: any) => ({
          valueExp: u.userId, displayExp: u.userName || ('User ' + u.userId), emailAddress: u.emailAddress || ''
        }));
        this._filterUsers(); this.cdr.detectChanges();
      }, error: () => { }
    });
  }

  private _filterUsers(): void {
    const s = this._userSearch.toLowerCase();
    this.filteredUserDropdownList = s
      ? this.userDropdownList.filter(u => u.displayExp.toLowerCase().includes(s))
      : [...this.userDropdownList];
  }

  setFieldType(type: EsignField['type']): void {
    if (this.envelopeSent) return;
    this.selectedFieldType = type;
    this.isPlacingField = true;
    this.cdr.detectChanges();
  }

  onPlacementCapture(event: MouseEvent): void {
    if (!this.isPlacingField) return;
    event.preventDefault(); event.stopPropagation();

    const canvasEl = this.pdfCanvas?.nativeElement;
    const el = this.fieldOverlay?.nativeElement;
    const refEl = canvasEl || el;

    if (!refEl) {
      this.isPlacingField = false;
      this.updateDerivedState();
      this.cdr.detectChanges();
      return;
    }

    const rect = refEl.getBoundingClientRect();
    const width = rect.width || 1;
    const height = rect.height || 1;
    const xPct = Math.max(0, Math.min(((event.clientX - rect.left) / width) * 100, 100));
    const yPct = Math.max(0, Math.min(((event.clientY - rect.top) / height) * 100, 100));

    const sz: Record<string, { w: number; h: number }> = {
      signature: { w: 20, h: 6 }, date: { w: 14, h: 5 },
      initials: { w: 10, h: 5 }, text: { w: 20, h: 5 }, redact: { w: 22, h: 6 }
    };
    const s = sz[this.selectedFieldType] || { w: 16, h: 5 };

    const f: EsignField = {
      fieldId: 'f_' + Date.now(),
      type: this.selectedFieldType,
      x: Math.max(0, Math.min(xPct - s.w / 2, 100 - s.w)),
      y: Math.max(0, Math.min(yPct - s.h / 2, 100 - s.h)),
      w: s.w, h: s.h,
      layerNo: this.selectedFieldType === 'redact' ? 0 : 1,
      assignedUserId: null, assignedUserName: '',
      pageNo: this.currentPage,
      label: this.selectedFieldType === 'redact' ? 'REDACT'
        : this.selectedFieldType.charAt(0).toUpperCase() + this.selectedFieldType.slice(1)
    };

    this.fields.push(f);
    this.selectedField = f;
    this.isPlacingField = false;
    this.updateDerivedState();
    this.cdr.detectChanges();
  }

  removeField(id: string, e?: MouseEvent): void {
    e?.stopPropagation();
    this.fields = this.fields.filter(f => f.fieldId !== id);
    this._chipEls.delete(id);
    if (this.selectedField?.fieldId === id) this.selectedField = null;
    this.updateDerivedState();
    this.cdr.detectChanges();
  }

  onViewerClick(e: MouseEvent): void { this.onPlacementCapture(e); }

  registerChipEl(fieldId: string, el: HTMLElement): void { this._chipEls.set(fieldId, el); }

  onChipMouseDown(event: MouseEvent, field: EsignField): void {
    if (event.button !== 0 || (event.target as HTMLElement).classList.contains('rh')) return;
    event.preventDefault(); event.stopPropagation();

    this.selectedField = field;
    this._dragField = field;
    this._resizing = false;
    this._overlayRect = this.fieldOverlay?.nativeElement?.getBoundingClientRect() ?? null;

    if (this._overlayRect) {
      this._dragOX = ((event.clientX - this._overlayRect.left) / this._overlayRect.width) * 100 - field.x;
      this._dragOY = ((event.clientY - this._overlayRect.top) / this._overlayRect.height) * 100 - field.y;
    }

    this._attach();
    this.cdr.detectChanges();
  }

  onResizeStart(event: MouseEvent, field: EsignField, handle: string): void {
    event.preventDefault(); event.stopPropagation();
    this.selectedField = field;
    this._resizing = true;
    this._resField = field;
    this._resHandle = handle;
    this._resStartX = event.clientX;
    this._resStartY = event.clientY;
    this._resStart = { x: field.x, y: field.y, w: field.w, h: field.h };
    this._overlayRect = this.fieldOverlay?.nativeElement?.getBoundingClientRect() ?? null;

    this._attach();
    this.cdr.detectChanges();
  }

  private _attach(): void {
    this._detach();
    this.zone.runOutsideAngular(() => {
      this._moveListener = (e: MouseEvent) => {
        e.preventDefault();
        if (!this._overlayRect) return;
        const W = this._overlayRect.width, H = this._overlayRect.height;
        if (!this._resizing && this._dragField) {
          const nx = Math.max(0, Math.min(((e.clientX - this._overlayRect.left) / W) * 100 - this._dragOX, 100 - this._dragField.w));
          const ny = Math.max(0, Math.min(((e.clientY - this._overlayRect.top) / H) * 100 - this._dragOY, 100 - this._dragField.h));
          this._dragField.x = nx; this._dragField.y = ny;
          const el = this._chipEls.get(this._dragField.fieldId);
          if (el) { el.style.left = nx + '%'; el.style.top = ny + '%'; }
        } else if (this._resizing && this._resField) {
          const dx = ((e.clientX - this._resStartX) / W) * 100;
          const dy = ((e.clientY - this._resStartY) / H) * 100;
          const s = this._resStart, f = this._resField, MW = 4, MH = 3;
          let nx = f.x, ny = f.y, nw = f.w, nh = f.h;
          switch (this._resHandle) {
            case 'se': nw = Math.max(MW, s.w + dx); nh = Math.max(MH, s.h + dy); break;
            case 'sw': nw = Math.max(MW, s.w - dx); nx = s.x + (s.w - nw); nh = Math.max(MH, s.h + dy); break;
            case 'ne': nw = Math.max(MW, s.w + dx); nh = Math.max(MH, s.h - dy); ny = s.y + (s.h - nh); break;
            case 'nw': nw = Math.max(MW, s.w - dx); nx = s.x + (s.w - nw); nh = Math.max(MH, s.h - dy); ny = s.y + (s.h - nh); break;
            case 'e': nw = Math.max(MW, s.w + dx); break;
            case 'w': nw = Math.max(MW, s.w - dx); nx = s.x + (s.w - nw); break;
            case 's': nh = Math.max(MH, s.h + dy); break;
            case 'n': nh = Math.max(MH, s.h - dy); ny = s.y + (s.h - nh); break;
          }
          nx = Math.max(0, Math.min(nx, 100 - nw)); ny = Math.max(0, Math.min(ny, 100 - nh));
          f.x = nx; f.y = ny; f.w = nw; f.h = nh;
          const el = this._chipEls.get(f.fieldId);
          if (el) { el.style.left = nx + '%'; el.style.top = ny + '%'; el.style.width = nw + '%'; el.style.height = nh + '%'; }
        }
      };

      this._upListener = () => {
        this._dragField = null; this._resizing = false; this._resField = null; this._resHandle = '';
        this._detach();
        this.zone.run(() => { this.updateDerivedState(); this.cdr.detectChanges(); });
      };

      document.addEventListener('mousemove', this._moveListener!, { passive: false });
      document.addEventListener('mouseup', this._upListener!);
    });
  }

  private _detach(): void {
    if (this._moveListener) { document.removeEventListener('mousemove', this._moveListener); this._moveListener = null; }
    if (this._upListener) { document.removeEventListener('mouseup', this._upListener); this._upListener = null; }
  }

  @HostListener('document:keydown.escape')
  onEsc(): void { this.isPlacingField = false; this.selectedField = null; this.cdr.detectChanges(); }

  selectField(f: EsignField): void {
    this.selectedField = f;
    this._chipEls.forEach((el, id) => {
      if (id === f.fieldId) el.classList.add('selected');
      else el.classList.remove('selected');
    });
  }

  deleteSelectedField(): void { if (this.selectedField) this.removeField(this.selectedField.fieldId); }

  chipLabel(f: EsignField): string {
    if (f.type === 'redact') return '■ REDACT';
    const name = f.assignedUserName ? f.assignedUserName.split(' ')[0] : '?';
    return 'L' + f.layerNo + ' ' + name;
  }
  getFieldBadgeClass(t: string): string { return ({ signature: 'fb-sig', date: 'fb-date', initials: 'fb-ini', text: 'fb-text', redact: 'fb-red' } as any)[t] || 'fb-text'; }
  getChipClass(t: string): string { return ({ signature: 'chip-signature', date: 'chip-date', initials: 'chip-initials', text: 'chip-text', redact: 'chip-redact' } as any)[t] || 'chip-text'; }
  trackByFieldId(_: number, f: EsignField): string { return f.fieldId; }
  trackByUserId(_: number, u: any): number { return u.valueExp; }

  assignUserToField(field: EsignField, userId: number | null): void {
    if (field.type === 'redact') return;
    if (!userId) {
      field.assignedUserId = null; field.assignedUserName = '';
    } else {
      // ONE USER PER LAYER: if Layer N already has User X, block assigning User Y to Layer N.
      if (field.layerNo) {
        const conflict = this.fields.find(f =>
          f.fieldId !== field.fieldId &&
          f.type !== 'redact' &&
          f.layerNo === field.layerNo &&
          !!f.assignedUserId &&
          f.assignedUserId !== +userId
        );
        if (conflict) {
          const existing = this.userDropdownList.find(x => x.valueExp === conflict.assignedUserId);
          this.showSnackBar(
            `Layer ${field.layerNo} is already assigned to "${existing?.displayExp || 'another user'}". One user per layer only.`,
            'E'
          );
          return;
        }
      }
      const u = this.userDropdownList.find(x => x.valueExp === +userId);
      if (u) { field.assignedUserId = +userId; field.assignedUserName = u.displayExp; }
    }
    this.updateDerivedState();
  }

  assignLayerToField(field: EsignField, layerNo: number): void {
    if (field.type === 'redact') return;
    const newLayer = +layerNo;
    // ONE USER PER LAYER: if the target layer already has a DIFFERENT user, warn.
    if (field.assignedUserId && newLayer) {
      const conflict = this.fields.find(f =>
        f.fieldId !== field.fieldId &&
        f.type !== 'redact' &&
        f.layerNo === newLayer &&
        !!f.assignedUserId &&
        f.assignedUserId !== field.assignedUserId
      );
      if (conflict) {
        const existing = this.userDropdownList.find(x => x.valueExp === conflict.assignedUserId);
        this.showSnackBar(
          `Layer ${newLayer} is already assigned to "${existing?.displayExp || 'another user'}". ` +
          'Change the user first, or pick a different layer.',
          'E'
        );
        return;
      }
    }
    field.layerNo = newLayer;
    this.updateDerivedState();
  }

  onLayerChange(field: EsignField, layer: number): void {
    this.assignLayerToField(field, layer); // reuse validation
    this.cdr.detectChanges();
  }

  createAndSendEnvelope(): void {
    if (!this.canSend) { this.showSnackBar(this.sendBlockReason || 'Please complete all fields.', 'E'); return; }
    this.isProcessing = true;
    const o = this.message.getOrgId().toString(), u = this.message.getUserId().toString();

    // ── ONE signer per FIELD (not per user/layer) ──────────────────────────
    // Same user on the same layer can have multiple fields (signature + date).
    // Each field gets its own signer record, each carrying its specific fieldId,
    // so IP_FIELD_ID is populated in the stored proc → no more fieldId: null.
    const signers = this.fields
      .filter(f => f.type !== 'redact' && !!f.assignedUserId)
      .map(f => {
        const usr = this.userDropdownList.find(x => x.valueExp === f.assignedUserId);
        return {
          orgId: parseInt(o),
          layerNo: f.layerNo,
          userId: f.assignedUserId,
          fieldId: f.fieldId,          // ← each signer tied to its specific field
          userName: usr?.displayExp || '',
          userFullName: usr?.displayExp || '',
          emailAddress: usr?.emailAddress || '',
          status: 'Pending'
        };
      })
      .sort((a, b) => a.layerNo - b.layerNo);
    // ── end of ONLY changed block ──────────────────────────────────────────

    const totalLayers = signers.length ? Math.max(...signers.map((s: any) => s.layerNo as number)) : 1;
    const payload = {
      orgId: parseInt(o), envelopeNo: null, documentId: this.documentData.documentId, version: this.documentData.version,
      envelopeTitle: this.envelopeTitle, status: 'Draft', totalLayers, currentLayer: 1,
      fieldMetadata: JSON.stringify(this.fields), completedOn: null, finalDocument: null, finalDocExtn: 'pdf',
      deleteReason: null, actionFlag: 'I', issueCommit: 'Y', createdBy: parseInt(u), signers
    };
    this.appService.createEsignEnvelope(payload).subscribe({
      next: (res: any) => {
        if (res?.resultType === 'S') {
          this.appService.sendEsignEnvelope(res.envelopeNo, parseInt(u)).subscribe({
            next: () => {
              this.isProcessing = false; this.envelopeSent = true;
              this.appService.getEsignEnvelope(res.envelopeNo).subscribe({ next: (f: any) => { this.sentEnvelopeData = f; this.cdr.detectChanges(); } });
              this.showSnackBar('E-Signature request sent!', 'S');
            },
            error: () => { this.isProcessing = false; this.showSnackBar('Created but could not send.', 'E'); }
          });
        } else { this.isProcessing = false; this.showSnackBar(res?.result || 'Failed.', 'E'); }
      },
      error: () => { this.isProcessing = false; this.showSnackBar('Server error. Please retry.', 'E'); }
    });
  }

  goBack(): void { this.router.navigate(['/dashboard/subFolder', this.message.breadcrumbData.secondLevel + '?v=' + Math.random()]); }

  showSnackBar(msg: string, type: string): void {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: 5000, data: { message: msg, type: type === 'S' ? 'Success' : 'Error', buttonLabel: 'Ok' },
      horizontalPosition: 'center', verticalPosition: 'top', panelClass: type === 'S' ? 'Success' : 'Error'
    });
    sb.onAction().subscribe(() => sb.dismiss());
  }
}
